export enum AlertThemes {
  SUCCESS = 'alert-theme-success',
  ERROR = 'alert-theme-error',
  INFO = 'alert-theme-info'
}